export default {
  API_ERROR: "Es tut uns leid, etwas ist schiefgelaufen. Bitte versuche es erneut.",
  FORM_ERROR: "Entschuldigung, aber du musst etwas mehr schreiben, um uns dein Feedback mitzuteilen."
}
